import { gql } from '@apollo/client';

const MARK_AS_FRAUD = gql`
  mutation MarkAsFraud(
    $customerId: String!
    $accountId: String!
    $references: [AuthorizationReferenceInput!]!
  ) {
    markAuthorizationsAsFraud(
      customerId: $customerId
      accountId: $accountId
      references: $references
      action: FRAUD
      actionLevel: CONFIRM_FRAUD
    ) {
      timestamps
      errors {
        errorCode
        transactionId
        errorMessage
      }
    }
  }
`;

const RESET_AUTHORIZATION_COUNTERS = gql`
  mutation ResetAuthorizationCounters($accountId: String!) {
    resetAccountDailyAuthorizationCounters(accountId: $accountId) {
      success
    }
  }
`;

const REVERSE_AUTHORIZATION = gql`
  mutation RemoveAuthorization(
    $customerId: String!
    $accountId: String!
    $removeAuthorizationInput: RemoveAuthorizationInput!
  ) {
    removeAuthorization(
      customerId: $customerId
      accountId: $accountId
      removeAuthorizationInput: $removeAuthorizationInput
    ) {
      success
    }
  }
`;

const WAIVE_FEE = gql`
  mutation WaiveFee(
    $accountId: String!
    $customerId: String
    $postedDate: String!
    $transactionId: String!
    $updatedReason: String
  ) {
    updateCustomerAdjustment(
      accountId: $accountId
      customerId: $customerId
      updateCustomerAdjRequest: {
        postedDate: $postedDate
        transactionId: $transactionId
        updatedReason: $updatedReason
      }
    ) {
      id
    }
  }
`;

export {
  MARK_AS_FRAUD,
  RESET_AUTHORIZATION_COUNTERS,
  REVERSE_AUTHORIZATION,
  WAIVE_FEE,
};
